import styled from "styled-components";
export const SaveCancelStyled = styled.div`
  margin-bottom: 15px;
  .btns-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1.5rem;
    margin-top: 2rem;
  }
`;
